import { fetchServerBuild, shouldWatchBuild, watchForNewBuild } from '@/clientOnlyUtils/buildVersion';
import React from 'react';
import toast from 'react-hot-toast';

import { Button } from '@poseidon/components/Input2';
import { Arrows } from '@poseidon/components/StrokeIcons';

import { env } from '~/env';

const NEW_VERSION_TOAST_ID = 'new-version-available';

/**
 * Offer a reload once a newer dashboard is deployed, so nobody keeps working in last deploy's UI
 * (a campaign page kept the old screens until reloaded). Shown once, never blocks; off in local dev.
 */
export function useNewVersionPrompt(): void {
  React.useEffect(() => {
    const clientBuild = env.NEXT_PUBLIC_GIT_SHA;
    if (!shouldWatchBuild(env.NODE_ENV, clientBuild) || clientBuild == null) return;
    return watchForNewBuild({
      clientBuild,
      fetchServerBuild: () => fetchServerBuild(),
      target: window,
      onNewBuild: () =>
        toast(
          () => (
            <span className="flex items-center gap-3" data-testid="new-version-toast">
              New version available
              <Button size="sm" color="blue" icon={<Arrows.RefreshCw04 />} onClick={() => window.location.reload()}>
                Reload
              </Button>
            </span>
          ),
          { id: NEW_VERSION_TOAST_ID, duration: Infinity },
        ),
    });
  }, []);
}
